import { ArrowBack } from "@material-ui/icons";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import "./Navbar.scss";

const Navbar: React.FC<RouteComponentProps> = ({ history }) => {
    return (
        <nav className="feedback__nav">
            <div className="back_button" onClick={() => history.goBack()}>
                <ArrowBack />
            </div>
            <h5>Story Feedback</h5>
        </nav>
    );
};

export default withRouter(Navbar);
